'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Chart = require('./Chart.css');

var _Chart2 = _interopRequireDefault(_Chart);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactChartjs = require('react-chartjs');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chartOptions = {
  segmentStrokeWidth: 0,
  percentageInnerCutout: 70,
  animationEasing: 'easeOutQuad',
  // String - Template string for single tooltips
  tooltipTemplate: "<%if (label){%><%=label %> <%}%><%= value + ' %' %>",
  // String - Template string for multiple tooltips
  multiTooltipTemplate: "<%= value + ' %' %>"
};

var Chart = (_dec = (0, _reactCssModules2.default)(_Chart2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Chart, _Component);

  function Chart(props) {
    (0, _classCallCheck3.default)(this, Chart);
    return (0, _possibleConstructorReturn3.default)(this, (Chart.__proto__ || (0, _getPrototypeOf2.default)(Chart)).call(this, props));
  }

  (0, _createClass3.default)(Chart, [{
    key: 'render',
    value: function render() {
      var chartData = [{
        value: this.props.toPerc,
        label: 'Tobacco producers',
        color: '#C3001C'
      }, {
        value: this.props.tmPerc,
        label: 'Entertainment companies',
        color: '#F2961C'
      }, {
        value: !(this.props.toPerc === 0 && this.props.tmPerc === 0) ? _convert2.default.float((100 - this.props.tmPerc - this.props.toPerc).toFixed(2)) : 0,
        label: 'Other',
        color: '#CCCCCC'
      }, {
        value: this.props.toPerc === 0 && this.props.tmPerc === 0 ? 100 : 0,
        label: 'Other',
        color: '#CCCCCC' // green
      }];
      var toIcon = require('../../../static/images/icon-cigarette.svg');
      var tmIcon = require('../../../static/images/icon-cinema.svg');
      var name = this.props.fundFamilyName;
      return _react2.default.createElement(
        'div',
        { styleName: 'grade-chart-wrapper' },
        _react2.default.createElement(
          _reactFlexboxGrid.Row,
          { styleName: 'grade-chart' },
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 6, md: 4, styleName: 'box' },
            this.props.tobaccoOverallRating ? _react2.default.createElement(
              'div',
              null,
              this.props.renderBox(name, this.props.tobaccoOverallRating, this.props.sri)
            ) : _react2.default.createElement(
              'div',
              null,
              this.props.renderBox()
            )
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 6, md: 4, styleName: 'chart' },
            _react2.default.createElement(_reactChartjs.Doughnut, { data: chartData, options: chartOptions, width: '300', height: '300' }),
            _react2.default.createElement(
              'div',
              { styleName: 'chart-details' },
              _react2.default.createElement(
                'div',
                { styleName: 'chart-assets' },
                _format2.default.money(this.props.invested, true, this.props.currency)
              ),
              this.props.toPerc > 0 && this.props.tmPerc === 0 ? _react2.default.createElement(
                'div',
                null,
                'INVESTED IN TOBACCO',
                _react2.default.createElement('br', null),
                'COMPANIES'
              ) : null,
              this.props.toPerc === 0 && this.props.tmPerc > 0 ? _react2.default.createElement(
                'div',
                null,
                'INVESTED IN',
                _react2.default.createElement('br', null),
                'TOBACCO-PROMOTING',
                _react2.default.createElement('br', null),
                'ENTERTAINMENT COMPANIES'
              ) : null,
              this.props.toPerc > 0 && this.props.tmPerc > 0 ? _react2.default.createElement(
                'div',
                null,
                'INVESTED IN TOBACCO',
                _react2.default.createElement('br', null),
                'AND TOBACCO-PROMOTING',
                _react2.default.createElement('br', null),
                'ENTERTAINMENT COMPANIES'
              ) : null,
              this.props.toPerc === 0 && this.props.tmPerc === 0 ? _react2.default.createElement(
                'div',
                null,
                'INVESTED IN TOBACCO',
                _react2.default.createElement('br', null),
                'OR TOBACCO-PROMOTING',
                _react2.default.createElement('br', null),
                'ENTERTAINMENT COMPANIES'
              ) : null
            )
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Col,
            { xs: 12, sm: 12, md: 4, styleName: 'labels' },
            _react2.default.createElement(
              'div',
              { styleName: 'tobacco' },
              _react2.default.createElement('img', { styleName: 'to-icon', src: toIcon, alt: 'Tobacco companies that produce or manufacture tobacco products' }),
              _react2.default.createElement(
                'div',
                { styleName: 'to-label' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'title' },
                  'Tobacco producers'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'intro' },
                  'that produce or manufacture tobacco products'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'movies' },
              _react2.default.createElement('img', { styleName: 'tm-icon', src: tmIcon, alt: 'Entertainment companies that show smoking in movies marketed to kids' }),
              _react2.default.createElement(
                'div',
                { styleName: 'tm-label' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'title' },
                  'Tobacco-promoting entertainment companies'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'intro' },
                  'that show smoking in movies marketed to kids'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Chart;
}(_react.Component), _class2.propTypes = {
  renderBox: _react.PropTypes.func.isRequired,
  currency: _react.PropTypes.string.isRequired,
  invested: _react.PropTypes.number.isRequired,
  tmPerc: _react.PropTypes.number.isRequired,
  toPerc: _react.PropTypes.number.isRequired,
  fundFamilyName: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = Chart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/Chart.js
// module id = 1272
// module chunks = 0